/**
 * useSyncExternalStore subscriber for cross-tab localStorage changes.
 * Module-level so its identity is stable and React never resubscribes.
 */
export function subscribeToStorage(onChange: () => void) {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
}
